export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-sketches-6c4edeea24f663037b144faf222ce528.png";